/**
 * 実行時の設定（app-config.json）を画面に渡す。
 */
import { createContext, useContext } from 'react';
import type { ReactNode } from 'react';
import type { RuntimeAppConfig } from './app-config';

const runtime_config_context = createContext<RuntimeAppConfig | null>(null);

export function RuntimeConfigProvider({ config, children }: { config: RuntimeAppConfig; children: ReactNode }) {
  return <runtime_config_context.Provider value={config}>{children}</runtime_config_context.Provider>;
}

export function useRuntimeConfig(): RuntimeAppConfig {
  const config = useContext(runtime_config_context);
  if (!config) {
    throw new Error('useRuntimeConfig は RuntimeConfigProvider の中で使います');
  }
  return config;
}
